// src/pages/ForceChangePasswordPage.js
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Alert, Button, Card, Col, Form, Row, Spinner } from "react-bootstrap";
import api from "../api";
import { AuthContext } from "../AuthContext";
import { dashboardPathFor } from "../dashboardPath";

export default function ForceChangePasswordPage() {
  const { user, updateUser } = useContext(AuthContext);
  const navigate = useNavigate();

  const [newPassword, setNewPassword]         = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError]                     = useState("");
  const [saving, setSaving]                   = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");

    if (!newPassword) {
      setError("Password is required.");
      return;
    }
    if (newPassword.length < 8) {
      setError("Password must be at least 8 characters.");
      return;
    }
    if (!/[A-Z]/.test(newPassword)) {
      setError("Password must contain at least one capital letter.");
      return;
    }
    if (!/[0-9]/.test(newPassword)) {
      setError("Password must contain at least one number.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }

    setSaving(true);
    try {
      await api.put("/auth/change-password", { new_password: newPassword });
      updateUser({ must_change_password: false });
      navigate(dashboardPathFor(user), { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || "Failed to change password. Please try again.");
    } finally {
      setSaving(false);
    }
  }

  return (
    <Row className="justify-content-center mt-5">
      <Col xs={12} sm={8} md={5} lg={4}>
        <Card>
          <Card.Header className="bg-warning text-dark fw-semibold">
            <i className="bi bi-key-fill me-2" />
            Password Change Required
          </Card.Header>
          <Card.Body>
            <p className="text-muted mb-3" style={{ fontSize: "0.9rem" }}>
              You must set a new password before continuing. It must be at least
              8 characters and include at least one capital letter and one number.
            </p>
            {error && <Alert variant="danger" className="py-2">{error}</Alert>}
            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-3">
                <Form.Label>New Password</Form.Label>
                <Form.Control
                  type="password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  autoFocus
                />
              </Form.Group>
              <Form.Group className="mb-4">
                <Form.Label>Confirm Password</Form.Label>
                <Form.Control
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </Form.Group>
              <Button type="submit" variant="primary" className="w-100" disabled={saving}>
                {saving ? <Spinner animation="border" size="sm" /> : "Set New Password"}
              </Button>
            </Form>
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
}
